<app-plans-checkout-wizard-dialog
    [plan]="plan?.plan"
    [checkoutInfo]="checkoutInfo"
    (succeed)="onSuccessResumePlanModal()"
    (closed)="closeResumePlanModal()">
</app-plans-checkout-wizard-dialog>
